import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APIRoutes } from '../global-misc/api-routes';
import { firstValueFrom } from 'rxjs';
import { FormFillStatusResponse, FormFillResponse, SubmitFormResponse } from '../global-data-models/form-fill.model';

@Injectable({ providedIn: 'root' })
export class FormFillService {
  constructor(private http: HttpClient) {}

  async checkFormFillStatus(assignmentId: string, token: string): Promise<FormFillStatusResponse> {
    const apiRoute = APIRoutes.FORM_FILL_CHECK_ROUTE.replace(':assignmentId', assignmentId).replace(':token', token);
    const response = await firstValueFrom(this.http.get<FormFillStatusResponse>(apiRoute));
    return response;
  }

  async getFormForFill(assignmentId: string, token: string): Promise<FormFillResponse> {
    const apiRoute = APIRoutes.FORM_FILL_GET_FORM.replace(':assignmentId', assignmentId).replace(':token', token);
    const response = await firstValueFrom(this.http.get<FormFillResponse>(apiRoute));
    return response;
  }

  async submitForm(assignmentId: string, token: string, submitData: SubmitFormResponse): Promise<any> {
    const apiRoute = APIRoutes.FORM_FILL_SUBMIT_FORM.replace(':assignmentId', assignmentId).replace(':token', token);
    const response = await firstValueFrom(this.http.post<any>(apiRoute, submitData));
    return response;
  }

  async postUploadFile(assignmentId: string, token: string, filePath: string): Promise<string> {
    const apiRoute = APIRoutes.FORM_FILL_UPLOAD_FILE.replace(':assignmentId', assignmentId).replace(':token', token);
    const response = await firstValueFrom(this.http.post<any>(apiRoute, { filePath }));
    return response;
  }
}
